/** 散布図の figcaption 用・読み方の箇条書き */
export function ScatterFigureLegend() {
  return (
    <figcaption className="win-rate-pick-scatter__figcaption">
      <ul className="win-rate-pick-scatter__legend">
        <li>
          <strong>縦軸</strong>：勝率（%）
        </li>
        <li>
          <strong>横軸</strong>：バンピック率（%、常用対数）。低い帯が潰れにくいようにしています（ツールチップのピック・BAN 表示と同じ換算の和）。
        </li>
        <li>
          <strong>色面・破線</strong>：等ティアスコアのゾーンの目安（上から S→D のイメージ）
        </li>
        <li>
          <strong>マーカー</strong>：顔アイコン。ホバーで数値を表示します。
        </li>
      </ul>
    </figcaption>
  );
}
